import { render, staticRenderFns } from "./test_help_info.vue?vue&type=template&id=50da361a&scoped=true"
import script from "./test_help_info.vue?vue&type=script&lang=js"
export * from "./test_help_info.vue?vue&type=script&lang=js"
import style0 from "./test_help_info.vue?vue&type=style&index=0&id=50da361a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da361a",
  null
  
)

export default component.exports